import React, { useState } from 'react'

import { classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { bool, number, string } from 'prop-types'

const FAQ_ITEMS = [
  {
    question: 'What counts toward my 25 monthly uses?',
    answer: 'AI generations and Marketplace downloads both count toward your monthly allowance.',
  },
  {
    question: 'What happens when I reach my monthly limit?',
    answer: "You'll need to wait until your monthly allowance resets. Additional usage "
      + 'options will be available soon.',
  },
  {
    question: 'Can I download Marketplace models and edit them with AI?',
    answer: 'Yes. You can enhance, edit, and customize your own models as well as eligible '
      + 'Marketplace models.',
  },
  {
    question: 'Do unused monthly uses roll over?',
    answer: 'No. Unused generations and downloads expire at the end of each billing cycle.',
  },
  {
    question: 'Can I cancel my Subscription at any time?',
    answer: 'You can cancel without a cancellation fee within the first 45 days. After that, an '
      + 'early cancellation fee equal to 50% of the remaining contract balance will apply.',
  },
]

function FaqItem({ id, question, answer, defaultOpen = false, showDivider = false }) {
  const [isOpen, setIsOpen] = useState(defaultOpen)
  const handleToggle = () => setIsOpen((open) => !open)

  const questionId = `ai-sub-landing-faq-question-${id}`
  const answerId = `ai-sub-landing-faq-answer-${id}`

  return (
    <div className="ai-sub-landing__faqs-item">
      <div className="ai-sub-landing__faqs-content">
        <button
          type="button"
          id={questionId}
          className="ai-sub-landing__faqs-question"
          aria-expanded={isOpen}
          aria-controls={answerId}
          onClick={handleToggle}
        >
          <span className="ai-sub-landing__faqs-question-text cgt-heading-200">{question}</span>
          <span
            className={classnames('ai-sub-landing__faqs-icon', isOpen && 'ai-sub-landing__faqs-icon--open')}
            aria-hidden
          >
            <span className="ai-sub-landing__faqs-icon-bar ai-sub-landing__faqs-icon-bar--horizontal" />
            <span className="ai-sub-landing__faqs-icon-bar ai-sub-landing__faqs-icon-bar--vertical" />
          </span>
        </button>
        <div
          className={classnames(
            'ai-sub-landing__faqs-answer-wrap',
            isOpen && 'ai-sub-landing__faqs-answer-wrap--open',
          )}
        >
          <div className="ai-sub-landing__faqs-answer-clip">
            <p
              id={answerId}
              role="region"
              aria-labelledby={questionId}
              aria-hidden={!isOpen}
              className="ai-sub-landing__faqs-answer cgt-body-md"
            >
              {answer}
            </p>
          </div>
        </div>
      </div>
      {showDivider && <div className="ai-sub-landing__faqs-divider" />}
    </div>
  )
}

FaqItem.propTypes = {
  id: number.isRequired,
  question: string.isRequired,
  answer: string.isRequired,
  defaultOpen: bool,
  showDivider: bool,
}

function FAQs() {
  return (
    <section className="ai-sub-landing__faqs">
      <div className="ai-sub-landing__faqs-intro">
        <h2 className="ai-sub-landing__faqs-title cgt-heading-500">Frequently Asked Questions</h2>
        <p className="ai-sub-landing__faqs-subtitle cgt-body-base">Find your answers here.</p>
      </div>
      <div className="ai-sub-landing__faqs-list">
        {FAQ_ITEMS.map((item, index) => (
          <FaqItem
            key={item.question}
            id={index}
            question={item.question}
            answer={item.answer}
            defaultOpen={index === 0}
            showDivider={index < FAQ_ITEMS.length - 1}
          />
        ))}
      </div>
    </section>
  )
}

export default FAQs
